<!-- Default Helpful Links Layout -->
<div *ngIf="show" class="external-links center" ngClass.lt-md="mobile-links">
  <platform-page-container [fullscreen]="false" [contentSpacing]="false">
    <div
      class="heading pad top-4x bottom-4x"
      fxLayout="row"
      fxLayoutAlign="center center"
    >
      <h2 class="font-medium" data-cy="external-links.heading" fxFlex>
        {{ 'external_links_heading' | translate }}
      </h2>
    </div>

    <div class="content-container">
      <!-- Column Links -->
      <div
        fxLayout.gt-sm="row"
        fxLayout.lt-md="column"
        fxLayoutAlign.gt-sm="center"
      >
        <div
          *ngFor="
            let category of links;
            trackBy: trackByName;
            let catIndex = index
          "
          [fxFlex.gt-sm]="flexWidth"
          fxFlex.lt-md="100"
        >
          <!-- Column Titles -->
          <h3
            class="title center dls-subhead-2-regular"
            [attr.data-cy]="'external-links.title.' + catIndex + '.desktop'"
          >
            {{ category.name | translate }}
          </h3>

          <!-- Column Links -->
          <ul class="content">
            <li
              class="linewrap"
              *ngFor="
                let link of category.links;
                trackBy: trackByName;
                let linkIndex = index
              "
            >
              <a
                class="link-blue"
                [attr.data-cy]="
                  'external-links.link.' + catIndex + '.' + linkIndex
                "
                [ngClass]="ccss.getClass('external_links')"
                [attr.href]="link.link | translate"
                target="_blank"
                >{{ link.text | translate }}</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div
        *ngIf="hasFootnote && showCustomerServiceLayout"
        fxLayout="row"
        fxLayoutAlign="center"
      >
        <p
          class="border-grey-top pad bottom-3x center"
          data-cy="external-links.note"
          ngClass.gt-sm="w-50"
          [innerHTML]="'home_footnote' | translate"
        ></p>
      </div>
    </div>
  </platform-page-container>
</div>
